var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    {
      attrs: {
        size: "mini",
        placeholder: "Sélection",
        multiple: "",
        filterable: "",
        clearable: ""
      },
      on: {
        change: function($event) {
          return _vm.onChange($event)
        },
        clear: function($event) {
          return _vm.onClear()
        }
      },
      model: {
        value: _vm.values,
        callback: function($$v) {
          _vm.values = $$v
        },
        expression: "values"
      }
    },
    [
      _c(
        "el-option-group",
        { key: "group1" },
        [
          _c(
            "el-option",
            {
              key: "0",
              attrs: { label: "Tous les clients", value: Number(0) }
            },
            [_vm._v("Tous les clients")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-option-group",
        { key: "group2" },
        _vm._l(_vm.clients, function(item) {
          return _c(
            "el-option",
            { key: item.id, attrs: { label: item.libelle, value: item.id } },
            [_vm._v(_vm._s(item.libelle))]
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }